<mat-toolbar color="primary" class="custom-primary mat-elevation-z3 recruiter">
  <button mat-icon-button (click)="drawerOpen = !drawerOpen">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="center-content">
    <span>
      <img class="logo" src="assets/images/logo-empresa.png" alt="" />
    </span>
  </div>
</mat-toolbar>
<mat-sidenav-container class="body custom-primary" autosize>
  <mat-sidenav #drawer mode="over" fixedInViewport (openedChange)="onOpenedChange($event)"
    [opened]="drawerOpen === true">
    <div class="profile-info" [ngClass]="{ uploading: progressUpload > 0 }">
      <ng-container *ngIf="avatarPicture; else defaultAvatar">
        <img [src]="avatarPicture" />
      </ng-container>
      <ng-template #defaultAvatar>
        <img [src]="
            user.gender === 'feminino'
              ? 'assets/images/avatar-female.png'
              : user.gender === 'masculino'
              ? 'assets/images/avatar-male.png'
              : 'assets/images/neutro.png'
          " style="height: 80px; width: auto !important" alt="" />
      </ng-template>
      <button id="avatar-button" mat-icon-button color="primary" (click)="openChooseFile()">
        <mat-icon>add_a_photo</mat-icon>
      </button>
      <input type="file" accept="image/*" style="visibility: hidden; height: 0; width: 0; overflow: hidden"
        (change)="changeAvatar($event)" #fileInput capture="user" />
    </div>
    <div class="progress-wrapper" *ngIf="progressUpload > 0">
      <mat-progress-bar mode="determinade" style="z-index: 999" [value]="progressUpload"></mat-progress-bar>
    </div>

    <mat-nav-list dense>
      <ng-container *ngFor="let item of menu">
        <a mat-list-item [routerLink]="item.routerLink" routerLinkActive="active" (click)="drawerOpen = false">
          <mat-icon matListIcon>{{ item.icon }}</mat-icon>
          {{ item.label }}
        </a>
      </ng-container>

      <mat-divider></mat-divider>
      <a mat-list-item style="color: red !important" (click)="logout()">
        <mat-icon matListIcon>exit_to_app</mat-icon>
        Sair
      </a>
    </mat-nav-list>
    <app-version-link customClass="version2"></app-version-link> 
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="container">
      <div class="stage">
        <!-- <div class="menu-left">

                    <div class="sticked">

                        <mat-card mat-elevation-2 style="margin-bottom: 20px;">
                            <div mat-card-image [ngClass]="{ uploading: progressUpload > 0 }">
                                <ng-container *ngIf="avatarPicture; else defaultAvatar">
                                    <img [src]="avatarPicture" alt="">
                                </ng-container>
                                <ng-template #defaultAvatar>
                                    <img [src]=" user.gender === 'masculino' ? '../../assets/images/avatar-male.png' : '../../assets/images/avatar-female.png' " 
                                        style="height: 80px; width: auto !important"
                                        alt=""/>
                                </ng-template>                            
                                <button id="avatar-button" mat-icon-button color="primary"
                                    (click)="openChooseFile()">
                                    <mat-icon>add_a_photo</mat-icon>
                                </button>
                                <input type="file" accept="image/*" style="visibility:hidden;height:0;width:0;overflow:hidden" (change)="changeAvatar($event)" #fileInput />
                                
                            </div>                        
                            <div class="progress-wrapper" *ngIf="progressUpload > 0">
                                <mat-progress-bar mode="determinade" style="z-index: 999;"  [value]="progressUpload"></mat-progress-bar>
                            </div>
                            <mat-card-content>
                                <p>{{ user.firstname }} {{ user.lastname }}</p>
                            </mat-card-content>
                        </mat-card>          

                        <mat-nav-list class="mat-elevation-z3" dense>

                            <ng-container *ngFor="let item of menu">
                                <a mat-list-item [routerLink]="item.routerLink" routerLinkActive="active">
                                    <mat-icon matListIcon>{{ item.icon }}</mat-icon>
                                    {{ item.label }}
                                </a>
                            </ng-container>
                            
                            <mat-divider></mat-divider>
                            <a mat-list-item style="color: red !important" (click)="logout()">
                                <mat-icon matListIcon>exit_to_app</mat-icon>
                                Sair
                            </a>
                        </mat-nav-list>

                    </div>

                </div> -->

        <div class="main-content mat-elevation-z3">
          <!-- <mat-progress-bar
            *ngIf="submiting"
            mode="indeterminate"
          ></mat-progress-bar> -->
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>